export const timelineEvents = [
  {
    id: 'web-security-2022',
    year: '2022',
    type: 'learning',
    title: 'Learned web development and web security',
    description:
      'Studied web development alongside web security fundamentals (OWASP Top 10), and found two informative bugs within the first couple of attempts.',
  },
  {
    id: 'bca-2023',
    year: '2023',
    type: 'education',
    title: 'BCA',
    description: 'Started My Journey at Navrachana in Bachelor of Computer Applications.',
  },
  {
    id: 'tomasi-cloud-2024',
    year: '2024',
    type: 'achievement',
    title: 'Built & Became a part of Tomasi',
    description:
      'Created Tomasi — the first end-to-end product shipped solo. Learned cloud fundamentals and earned a certification, while working as a full-stack developer and DevOps engineer building out cloud infrastructure.',
  },
  {
    id: 'cicd-2025',
    year: '2025',
    type: 'learning',
    title: 'Refined development workflow with CI/CD',
    description:
      'Sharpened development practices and built a CI/CD pipeline using Jenkins to automate builds and deployments.',
  },
  {
    id: 'ai-2026',
    year: '2026',
    type: 'project',
    title: 'AI analytics assistant, dashboard, and Lambda pipeline',
    description:
      'Built an AI-powered analytics assistant and an analytics dashboard, and shipped the image compression Lambda pipeline.',
  },
]
